import React, { Component } from 'react'

export default class DropdownMaster extends Component {
    render() {
        const { label, require, name, value, disable, defaultValue, fpgerror, selectedDrop, optionDisableIndex, isOptionDisabled, isdefaultDisable } = this.props

        const options = this.props.options && this.props.options.map(function (option, i) {
            return (
                <>{
                    isOptionDisabled ?
                        <option defaultValue={defaultValue} disabled={option.index <= optionDisableIndex ? true : false} key={option._id} value={option._id}>{option.name}</option> :
                        <option defaultValue={defaultValue} key={option._id} value={option._id}>{option.name}</option>
                }
                </>
            )
        })

        return (
            <div className="field_row_inner">
                {label ? <label className={`${require ? 'required' : null}`}>{label}</label> : ""}
                <div className="select_field relative">
                    <select disabled={disable} name={name} onChange={(e) => this.props.onChange(e)} value={value}>
                        {selectedDrop ?
                            ''
                            : name === 'awardCategory' ? <option selected value={''}>Select From Below</option> : <option value={''} disabled={isdefaultDisable ? !isdefaultDisable : true} selected>Select From Below</option>}
                        {options}
                    </select>
                    {fpgerror ? <span className="error" style={{ color: 'red' }} >{fpgerror}</span> : ""}
                </div>
            </div>
        )
    }
}